module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-c9d0f21a.png";